import { CircleDot } from "lucide-react";
import { AdminFilterMenu } from "@/components/admin/AdminFilterMenu";
import type { StatusFilter } from "@/components/admin/adminListStatus";

export type AdminStatusFilterLabels = {
  name: string;
  all: string;
  active: string;
  inactive: string;
};

type AdminStatusFilterProps = {
  value: StatusFilter;
  onChange: (value: StatusFilter) => void;
  counts: Record<StatusFilter, number>;
  labels: AdminStatusFilterLabels;
};

export function AdminStatusFilter({
  value,
  onChange,
  counts,
  labels,
}: AdminStatusFilterProps) {
  return (
    <AdminFilterMenu
      icon={CircleDot}
      name={labels.name}
      value={value}
      defaultValue="all"
      onChange={onChange}
      options={[
        {
          value: "all" as const,
          label: labels.all,
          count: counts.all,
        },
        {
          value: "active" as const,
          label: labels.active,
          count: counts.active,
          statusDot: "active",
        },
        {
          value: "inactive" as const,
          label: labels.inactive,
          count: counts.inactive,
          statusDot: "inactive",
        },
      ]}
    />
  );
}
